import type { ClCampaign, ClFilterDef } from './types';

export const CL_CAMPAIGNS: ClCampaign[] = [
  {
    id: 1,
    name: 'Emergency Dental — Same Day',
    target: '5 mi radius',
    icon: '🚨',
    active: true,
    spend: 620,
    budget: 800,
    leads: 62,
    booked: 22,
    noShows: 2,
    revenue: 8400,
    costPerPatient: 28,
    roi: 13.5,
    health: 'optimal',
    alert:
      'Generating $13.50 for every $1 spent. Consider increasing budget by $200 to capture more weekend demand.',
    alertType: 'success',
    lpPhase: 'converged',
  },
  {
    id: 2,
    name: 'Dental Implants — All-on-4',
    target: '10 mi radius',
    icon: '🦷',
    active: true,
    spend: 890,
    budget: 1000,
    leads: 26,
    booked: 8,
    noShows: 1,
    revenue: 33600,
    costPerPatient: 111,
    roi: 37.8,
    health: 'optimal',
    alert:
      'Highest ROI campaign — each implant patient is worth $4,200. Weekend ads performing 3x better than weekday.',
    alertType: 'success',
    lpPhase: 'exploitation',
  },
  {
    id: 3,
    name: 'Teeth Whitening — Spring Special',
    target: '5 mi radius',
    icon: '✨',
    active: true,
    spend: 180,
    budget: 250,
    leads: 26,
    booked: 11,
    noShows: 0,
    revenue: 3850,
    costPerPatient: 16,
    roi: 21.4,
    health: 'optimal',
    alert:
      'Low cost, high volume — your best cost-per-patient campaign. Spring demand still rising.',
    alertType: 'success',
    lpPhase: 'exploration',
  },
  {
    id: 4,
    name: 'Invisalign — Adults 25-45',
    target: '8 mi radius',
    icon: '😁',
    active: true,
    spend: 445,
    budget: 500,
    leads: 32,
    booked: 14,
    noShows: 1,
    revenue: 77000,
    costPerPatient: 32,
    roi: 173.0,
    health: 'optimal',
    alert:
      'Diamond provider status is driving higher CTR than market average. Lifetime value makes this your most profitable campaign.',
    alertType: 'success',
    lpPhase: 'validation',
  },
  {
    id: 5,
    name: 'Family Dentist — Near Me',
    target: '5 mi radius',
    icon: '👨‍👩‍👧',
    active: true,
    spend: 320,
    budget: 400,
    leads: 44,
    booked: 16,
    noShows: 2,
    revenue: 5600,
    costPerPatient: 20,
    roi: 17.5,
    health: 'learning',
    alert:
      'New ad variant being tested. ELVA is optimizing for the best-performing headline — results expected in 3 days.',
    alertType: 'neutral',
    lpPhase: 'exploration',
  },
  {
    id: 6,
    name: 'Dentista de Emergencia',
    target: '5 mi radius',
    icon: '🇪🇸',
    active: true,
    spend: 95,
    budget: 150,
    leads: 18,
    booked: 9,
    noShows: 0,
    revenue: 2880,
    costPerPatient: 11,
    roi: 30.3,
    health: 'optimal',
    alert:
      'Lowest cost per patient across all campaigns ($11). Zero no-shows. Consider doubling the budget.',
    alertType: 'success',
    lpPhase: 'exploitation',
  },
  {
    id: 7,
    name: 'Cosmetic Veneers — Premium',
    target: '8 mi radius',
    icon: '💎',
    active: true,
    spend: 340,
    budget: 400,
    leads: 12,
    booked: 3,
    noShows: 1,
    revenue: 4200,
    costPerPatient: 113,
    roi: 12.4,
    health: 'attention',
    alert:
      'CPC rising 18% this week due to new competitor. ELVA is shifting to long-tail keywords to reduce cost. Monitor for 5 days.',
    alertType: 'warning',
    lpPhase: 'validation',
  },
  {
    id: 8,
    name: 'Weekend Emergency Walk-In',
    target: '5 mi radius',
    icon: '🏥',
    active: true,
    spend: 210,
    budget: 300,
    leads: 30,
    booked: 15,
    noShows: 1,
    revenue: 5250,
    costPerPatient: 14,
    roi: 25.0,
    health: 'optimal',
    alert:
      'Friday 4-8 PM is your highest-converting window. ELVA increased bids 20% during this slot.',
    alertType: 'success',
    lpPhase: 'exploitation',
  },
  {
    id: 9,
    name: 'Sedation Dentistry',
    target: '10 mi radius',
    icon: '😴',
    active: false,
    spend: 0,
    budget: 200,
    leads: 0,
    booked: 0,
    noShows: 0,
    revenue: 0,
    costPerPatient: 0,
    roi: 0,
    health: 'paused',
    alert:
      'Paused — low search volume season. ELVA will recommend restarting when demand picks up.',
    alertType: 'neutral',
    lpPhase: null,
  },
];

export const CL_FILTERS: ClFilterDef[] = [
  { id: 'all', label: 'All' },
  { id: 'active', label: 'Active' },
  { id: 'attention', label: 'Needs Attention' },
  { id: 'paused', label: 'Paused' },
];
